import { Routes, Route } from 'react-router-dom';
import { SickleRegistration } from '../modules/sickle/components/SickleRegistration';
import DiseaseManagement from '../modules/sickle/components/DiseaseManagement';
import SickleMedication from '../modules/sickle/components/SickleMedication';
import Searchpatient from '../modules/sickle/components/Searchpatient';

const SickleRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SickleRegistration />} />
      <Route path="/registration" element={<SickleRegistration />} />
      <Route path="/disease-management" element={<DiseaseManagement />} />
      <Route path="/medication" element={<SickleMedication />} />
      <Route path="/search" element={<Searchpatient />} />
    </Routes>
  );
};

export default SickleRoutes;